import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import XLSX from "xlsx";
import {
  Button,
  Checkbox,
  Container,
  Divider,
  Header,
  Icon,
  Form,
  Loader,
  Menu,
  Message,
  Modal,
  Segment
} from "semantic-ui-react";
import { find, snakeCase } from "lodash";
import { orderBy } from "lodash";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import update from "immutability-helper";
import moment from "moment";
import numeral from "numeral";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const numberMask = createNumberMask({
  prefix: "",
  allowDecimal: true,
  requireDecimal: true,
  allowNegative: true
});

const INITIAL_STATE = {
  loading: false,
  data: null,
  error: null,
  asentarRendicionModal: {
    open: false,
    loading: false,
    error: null,
    values: {
      id: null,
      fechaRendicion: moment().format("YYYY-MM-DD"),
      fondosRecibidos: 0,
      importeRendicion: 0,
      saldoPorRendir: 0
    }
  },
  removeRendicionModal: {
    open: false,
    loading: false,
    error: null,
    rendicionId: null
  },
  erogacionModal: {
    open: false,
    loading: false,
    error: null,
    values: {
      id: null,
      fecha: moment().format("YYYY-MM-DD"),
      nroComprobante: "",
      razonSocial: "",
      importe: 0
    }
  },
  paymentModal: {
    open: false,
    loading: false,
    error: null,
    values: {
      concepto: "Pago",
      fecha: moment().format("YYYY-MM-DD")
    }
  },
  editCuotaModal: {
    open: false,
    loading: false,
    error: null,
    values: {
      id: null,
      concepto: "",
      monto: "",
      montoOriginal: "",
      transacciones: []
    }
  },
  removePagoModal: {
    open: false,
    loading: false,
    error: null,
    transaccionId: null
  },
  nuevaCuotaModal: {
    open: false,
    loading: false,
    error: null,
    values: {
      mode: "",
      nro: 1,
      cantidad: 1,
      concepto: "Cuota",
      periodoDesde: moment()
        .set("date", 1)
        .format("YYYY-MM-DD"),
      periodoHasta: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      vencimiento: moment()
        .set("date", 10)
        .format("YYYY-MM-DD"),
      diaVencimiento: 10,
      intervaloVencimiento: 1,
      monto: 0.0
    }
  }
};

const intervaloVencimientoOptions = [
  {
    key: 0,
    text: "MENSUAL",
    value: 1
  },
  {
    key: 1,
    text: "BIMESTRAL",
    value: 2
  },
  {
    key: 2,
    text: "TRIMESTRAL",
    value: 3
  },
  {
    key: 3,
    text: "CUTRIMESTRAL",
    value: 4
  },
  {
    key: 4,
    text: "SEMESTRAL",
    value: 6
  },
  {
    key: 5,
    text: "ANUAL",
    value: 12
  }
];

class CoopPrestamosDetalleView extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.PrestamoService = props.feathers.service("api/prestamos");
    this.PagoService = props.feathers.service("api/pagos");
    this.CuotaService = props.feathers.service("api/cuotas");
    this.TransaccionService = props.feathers.service("api/transacciones");
    this.RendicionService = props.feathers.service("api/rendiciones");
    this.ErogacionService = props.feathers.service("api/erogaciones");
  }

  findPrestamo = () => {
    this.setState({
      loading: true,
      data: null,
      error: null
    });

    this.PrestamoService.get(this.props.match.params.prestamo)
      .then(prestamo => {
        console.log(prestamo);
        this.setState({
          loading: false,
          data: {
            ...prestamo,
            cuotas: orderBy(
              prestamo.cuotas.map(cuota => ({
                ...cuota,
                pagar: 0,
                incluirPago: false
              })),
              ["nro"],
              ["asc"]
            )
          }
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
          error
        });
      });
  };

  cancelarDeuda = () => {
    let { data: prestamo } = this.state;
    let cuotas = [...prestamo.cuotas];

    let aPagar = cuotas.map(cuota => {
      let saldo = this.calcultarSaldoCuota(cuota.transacciones, true);

      if (saldo !== 0) {
        return {
          ...cuota,
          pagar: Math.abs(saldo),
          incluirPago: true
        };
      } else {
        return cuota;
      }
    });

    this.setState(
      update(this.state, {
        paymentModal: {
          $merge: {
            open: true
          },
          values: {
            $merge: {
              concepto: "Cancelacion"
            }
          }
        },
        data: {
          cuotas: {
            $set: aPagar
          }
        }
      })
    );
  };

  openErogacionModal = () => {
    this.setState(
      update(this.state, {
        erogacionModal: {
          $merge: {
            open: true
          }
        }
      })
    );
  };

  dismissErogacionModal = () => {
    this.setState(
      update(this.state, {
        erogacionModal: {
          $set: INITIAL_STATE.erogacionModal
        }
      })
    );
  };

  openAsentarRendicionModal = () => {
    let {
      data: { rendicion }
    } = this.state;

    if (rendicion) {
      console.log(rendicion.erogaciones);
      let importeRendicion = 0;

      if (rendicion.erogaciones) {
        importeRendicion = rendicion.erogaciones.reduce((prev, curr) => {
          return prev + numeral(curr.importe).value();
        }, 0);
      }

      this.setState(
        update(this.state, {
          asentarRendicionModal: {
            $merge: {
              open: true,
              values: {
                id: rendicion.id,
                fechaRendicion: moment(rendicion.fechaRendicion)
                  .parseZone()
                  .format("YYYY-MM-DD"),
                fondosRecibidos: rendicion.fondosRecibidos,
                importeRendicion,
                saldoPorRendir: rendicion.saldoPorRendir
              }
            }
          }
        })
      );
    } else {
      this.setState(
        update(this.state, {
          asentarRendicionModal: {
            $merge: {
              open: true
            }
          }
        })
      );
    }
  };

  dismissAsentarRendicionModal = () => {
    let { asentarRendicionModal } = this.state;

    this.setState({
      asentarRendicionModal: INITIAL_STATE.asentarRendicionModal
    });
  };

  erogacionInputHandler = (e, input) => {
    let name, value;

    if (input) {
      name = input.name;
      if (input.type === "checkbox") {
        value = input.checked;
      } else {
        value = input.value;
      }
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    this.setState(
      update(this.state, {
        erogacionModal: {
          values: {
            $merge: {
              [name]: value
            }
          }
        }
      }),
      () => console.log(this.state.erogacionModal.values)
    );
  };

  rendicionInputHandler = (e, input) => {
    let name, value;

    if (input) {
      name = input.name;
      if (input.type === "checkbox") {
        value = input.checked;
      } else {
        value = input.value;
      }
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    this.setState(
      update(this.state, {
        asentarRendicionModal: {
          values: {
            $merge: {
              [name]: value
            }
          }
        }
      })
    );
  };

  findErogaciones = () => {
    let {
      data: { rendicion },
      asentarRendicionModal
    } = this.state;

    this.setState(
      update(this.state, {
        asentarRendicionModal: {
          $merge: {
            loading: true
          }
        }
      })
    );

    this.ErogacionService.find({
      query: { RendicionId: rendicion.id }
    })
      .then(response => {
        console.log("findErogaciones", response);

        let importeRendicion = 0;

        if (response) {
          importeRendicion = response.reduce((prev, curr) => {
            return prev + numeral(curr.importe).value();
          }, 0);
        }

        this.setState(
          update(this.state, {
            data: {
              rendicion: {
                erogaciones: {
                  $set: response
                }
              }
            },
            asentarRendicionModal: {
              $merge: {
                loading: false,
                values: {
                  ...asentarRendicionModal.values,
                  importeRendicion
                }
              }
            }
          })
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            asentarRendicionModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  removeErogacion = erogacion => {
    this.setState(
      update(this.state, {
        asentarRendicionModal: {
          $merge: {
            loading: true
          }
        }
      })
    );

    this.ErogacionService.remove(erogacion.id)
      .then(response => {
        this.setState(
          update(this.state, {
            asentarRendicionModal: {
              $merge: {
                loading: false
              }
            }
          }),
          this.findErogaciones
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            asentarRendicionModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  submitErogacion = () => {
    let {
      data: { rendicion },
      erogacionModal
    } = this.state;

    this.setState(
      update(this.state, {
        erogacionModal: {
          $merge: {
            loading: true
          }
        }
      })
    );

    this.ErogacionService.create({
      ...erogacionModal.values,
      RendicionId: rendicion.id
    })
      .then(response => {
        this.setState(
          update(this.state, {
            erogacionModal: {
              $set: INITIAL_STATE.erogacionModal
            }
          }),
          this.findErogaciones
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            erogacionModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  submitRendicion = e => {
    let { asentarRendicionModal } = this.state;

    this.setState(
      update(this.state, {
        asentarRendicionModal: {
          $merge: {
            loading: true
          }
        }
      })
    );

    if (asentarRendicionModal.values.id) {
      this.RendicionService.patch(
        asentarRendicionModal.values.id,
        asentarRendicionModal.values
      )
        .then(response => {
          this.setState(
            update(this.state, {
              asentarRendicionModal: {
                $merge: {
                  loading: false
                }
              },
              data: {
                $merge: {
                  rendicion: response
                }
              }
            }),
            () => console.log(this.state.data)
          );
        })
        .catch(error => {
          this.setState(
            update(this.state, {
              asentarRendicionModal: {
                $merge: {
                  loading: false,
                  error
                }
              }
            })
          );
        });
    } else {
      this.RendicionService.create({
        ...asentarRendicionModal.values,
        PrestamoId: this.props.match.params.prestamo
      })
        .then(response => {
          this.setState(
            update(this.state, {
              asentarRendicionModal: {
                $merge: {
                  loading: false,
                  values: {
                    ...asentarRendicionModal.values,
                    id: response.id
                  }
                }
              },
              data: {
                $merge: {
                  rendicion: response
                }
              }
            })
          );
        })
        .catch(error => {
          this.setState(
            update(this.state, {
              asentarRendicionModal: {
                $merge: {
                  loading: false,
                  error
                }
              }
            })
          );
        });
    }
  };

  openPaymentModal = () => {
    this.setState(
      update(this.state, {
        paymentModal: {
          $merge: {
            open: true
          }
        }
      })
    );
  };

  dissmissPaymentModal = () => {
    let { data } = this.state;
    let cuotas = data.cuotas.map(cuota => ({
      ...cuota,
      incluirPago: false,
      pagar: 0
    }));

    this.setState({
      paymentModal: INITIAL_STATE.paymentModal,
      data: {
        ...this.state.data,
        cuotas: cuotas
      }
    });
  };

  openRemovePagoModal = (e, transaccionId) => {
    console.log(transaccionId);
    this.setState(
      update(this.state, {
        removePagoModal: {
          $merge: {
            open: true,
            transaccionId
          }
        }
      })
    );
  };

  dismissRemovePagoModal = () => {
    this.setState(
      update(this.state, {
        removePagoModal: {
          $set: INITIAL_STATE.removePagoModal
        }
      })
    );
  };

  openBorrarRendicionModal = rendicion => {
    this.setState(
      update(this.state, {
        removeRendicionModal: {
          $merge: {
            open: true,
            rendicionId: rendicion.id
          }
        }
      })
    );
  };

  dismissRendicionModal = () => {
    this.setState(
      update(this.state, {
        removeRendicionModal: {
          $set: INITIAL_STATE.removeRendicionModal
        }
      })
    );
  };

  submitRemoveRendicion = () => {
    let { removeRendicionModal } = this.state;

    this.setState(
      update(this.state, {
        removeRendicionModal: {
          $merge: {
            loading: true
          }
        }
      })
    );

    this.RendicionService.remove(removeRendicionModal.rendicionId)
      .then(response => {
        this.setState(
          update(this.state, {
            removeRendicionModal: {
              $set: INITIAL_STATE.removeRendicionModal
            },
            data: {
              $merge: {
                rendicion: null
              }
            }
          })
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            removeRendicionModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  openNuevaCuotaModal = e => {
    this.setState(
      update(this.state, {
        nuevaCuotaModal: {
          $merge: {
            open: true,
            values: {
              ...this.state.nuevaCuotaModal.values,
              nro: this.state.data ? this.state.data.cuotas.length + 1 : 1,
              concepto: "Cuota"
            }
          }
        }
      })
    );
  };

  dismissNuevaCuotaModal = e => {
    this.setState(
      update(this.state, {
        nuevaCuotaModal: {
          $set: INITIAL_STATE.nuevaCuotaModal
        }
      })
    );
  };

  nuevaCuotaInputHandler = (e, input) => {
    let name, value;

    if (input) {
      name = input.name;
      if (input.type === "checkbox") {
        value = input.checked;
      } else {
        value = input.value;
      }
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    this.setState(
      update(this.state, {
        nuevaCuotaModal: {
          values: {
            $merge: {
              [name]: value
            }
          }
        }
      })
    );
  };

  submitNuevaCuota = e => {
    let { nuevaCuotaModal } = this.state;

    this.setState(
      update(this.state, {
        nuevaCuotaModal: {
          $merge: {
            loading: true
          }
        }
      })
    );

    this.CuotaService.create({
      ...nuevaCuotaModal.values,
      PrestamoId: this.props.match.params.prestamo
    })
      .then(response => {
        this.dismissNuevaCuotaModal();
        this.findPrestamo();
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            nuevaCuotaModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  submitRemoveTransaccion = e => {
    e.preventDefault();

    let {
      removePagoModal: { transaccionId }
    } = this.state;

    this.setState(
      update(this.state, {
        removePagoModal: {
          $merge: {
            loading: true,
            error: null
          }
        }
      })
    );

    this.TransaccionService.remove(transaccionId)
      .then(response => {
        this.setState(
          update(this.state, {
            removePagoModal: {
              $set: INITIAL_STATE.removePagoModal
            }
          }),
          () => {
            this.findPrestamo();
          }
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            removePagoModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  modalInputHandler = (e, input) => {
    this.setState(
      update(this.state, {
        paymentModal: {
          values: {
            $merge: {
              [input.name]: input.value
            }
          }
        }
      })
    );
  };

  editCuotaInputHandler = e => {
    this.setState(
      update(this.state, {
        editCuotaModal: {
          values: {
            $merge: {
              [e.target.name]: e.target.value
            }
          }
        }
      })
    );
  };

  submitPago = e => {
    e.preventDefault();

    let { data, paymentModal } = this.state;
    let some = data.cuotas.some(cuota => cuota.incluirPago);

    if (some) {
      let payments = data.cuotas
        .filter(c => c.incluirPago)
        .map(cuota => {
          let pago = numeral(cuota.pagar).value();
          let saldo = Math.abs(
            this.calcultarSaldoCuota(cuota.transacciones, true)
          );

          if (pago > saldo) {
            pago = saldo;
          }

          return {
            concepto: paymentModal.values.concepto,
            pago: pago,
            CuotaId: cuota.id
          };
        });

      this.setState(
        update(this.state, {
          paymentModal: {
            $merge: {
              loading: true,
              error: null
            }
          }
        })
      );

      this.PagoService.create({
        concepto: paymentModal.values.concepto,
        fecha: paymentModal.values.fecha,
        monto: payments.reduce((prev, curr) => prev + curr.pago, 0),
        transacciones: payments,
        PrestamoId: data.id
      })
        .then(response => {
          this.setState(
            update(this.state, {
              paymentModal: {
                $set: INITIAL_STATE.paymentModal
              }
            }),
            this.findPrestamo
          );
          this.props.findPrestamos();
        })
        .catch(error => {
          console.log(error);
          this.setState(
            update(this.state, {
              paymentModal: {
                $merge: {
                  loading: false,
                  error: error
                }
              }
            })
          );
        });
    } else {
      this.dissmissPaymentModal();
    }
  };

  incluirPago = cellInfo => {
    const { data: prestamo } = this.state;
    const data = [...prestamo.cuotas];

    if (!data[cellInfo.index][cellInfo.column.id]) {
      data[cellInfo.index].pagar = numeral(
        Math.abs(
          this.calcultarSaldoCuota(cellInfo.original.transacciones, true)
        )
      ).format("0,0.00");
    } else {
      data[cellInfo.index].pagar = 0;
    }

    data[cellInfo.index][cellInfo.column.id] = !data[cellInfo.index][
      cellInfo.column.id
    ];

    this.setState(
      update(this.state, {
        data: {
          $merge: {
            cuotas: data
          }
        }
      })
    );
  };

  calcultarSaldoCuota = (transacciones, plain = false) => {
    let saldo = transacciones.reduce(
      (prev, curr) => prev + numeral(curr.monto).value(),
      0
    );

    if (plain) {
      return numeral(saldo).value();
    } else if (saldo < 0) {
      return (
        <span style={{ color: "red" }}>
          <b>{numeral(saldo).format("(0,0.00)")}</b>
        </span>
      );
    } else {
      return numeral(saldo).format("(0,0.00)");
    }
  };

  openEditCuotaModal = (e, cuota) => {
    this.setState(
      update(this.state, {
        editCuotaModal: {
          $merge: {
            open: true,
            error: null,
            values: {
              id: cuota.id,
              concepto: cuota.concepto,
              monto: this.calcultarSaldoCuota(cuota.transacciones, true),
              transacciones: cuota.transacciones,
              montoOriginal: numeral(cuota.monto).format("(0,0.00)")
            }
          }
        }
      })
    );
  };

  dismissEditCuotaModal = (e, cuota) => {
    this.setState(
      update(this.state, {
        editCuotaModal: {
          $set: INITIAL_STATE.editCuotaModal
        }
      })
    );
  };

  removeCuota = e => {
    let {
      editCuotaModal: { values }
    } = this.state;

    this.setState(
      update(this.state, {
        editCuotaModal: {
          $merge: {
            loading: true,
            error: null
          }
        }
      })
    );

    this.CuotaService.remove(values.id)
      .then(response => {
        this.setState(
          update(this.state, {
            editCuotaModal: {
              $set: INITIAL_STATE.editCuotaModal
            }
          }),
          () => {
            this.findPrestamo();
          }
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            editCuotaModal: {
              $set: INITIAL_STATE.editCuotaModal
            }
          })
        );
      });
  };

  submitCuotaEdition = () => {
    let {
      editCuotaModal: { values }
    } = this.state;

    this.setState(
      update(this.state, {
        editCuotaModal: {
          $merge: {
            loading: true,
            error: null
          }
        }
      })
    );

    this.CuotaService.patch(values.id, {
      concepto: values.concepto,
      ajuste: values.monto,
      saldo: this.calcultarSaldoCuota(values.transacciones, true),
      montoOriginal: values.montoOriginal
    })
      .then(response => {
        this.setState(
          update(this.state, {
            editCuotaModal: {
              $set: INITIAL_STATE.editCuotaModal
            }
          }),
          () => {
            this.findPrestamo();
          }
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            editCuotaModal: {
              $set: INITIAL_STATE.editCuotaModal
            }
          })
        );
      });
  };

  renderEditable = () => cellInfo => {
    let { data: prestamo } = this.state;

    if (cellInfo.original.incluirPago) {
      return (
        <div
          style={{ backgroundColor: "#fafafa", textAlign: "right" }}
          contentEditable
          suppressContentEditableWarning
          onBlur={e => {
            const data = [...prestamo.cuotas];
            let value = e.target.innerHTML;

            data[cellInfo.index][cellInfo.column.id] = numeral(value)
              ? numeral(value).format("0,0.00")
              : "0.00";

            this.setState(
              update(this.state, {
                data: {
                  $merge: {
                    cuotas: data
                  }
                }
              })
            );
          }}
          dangerouslySetInnerHTML={{
            __html: prestamo.cuotas[cellInfo.index][cellInfo.column.id]
          }}
        />
      );
    } else {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            textAlign: "right"
          }}>
          <div
            style={{
              width: `100%`,
              height: "100%"
            }}>
            ---
          </div>
        </div>
      );
    }
  };

  downloadExcel = e => {
    e.preventDefault();

    let { data } = this.state;

    console.log("@prestamo", data);

    let xlsData = [];

    data.cuotas.forEach(cuota => {
      let acc = numeral();

      for (let i = 0; i < cuota.nro; i++) {
        let cuota = find(data.cuotas, cuota => {
          return cuota.nro === i + 1;
        });

        if (cuota) {
          acc.add(this.calcultarSaldoCuota(cuota.transacciones, true));
        }
      }

      xlsData.push({
        Concepto: `${cuota.concepto} ${cuota.nro}`,
        Periodo: `${moment(cuota.periodoDesde)
          .parseZone()
          .format("DD/MM/YYYY")} - ${moment(cuota.periodoHasta)
          .parseZone()
          .format("DD/MM/YYYY")}`,
        Vencimiento: `${moment(cuota.vencimiento)
          .parseZone()
          .format("DD/MM/YYYY")}`,
        Monto: numeral(cuota.monto).format("(0,0.00)"),
        Saldo: numeral(
          this.calcultarSaldoCuota(cuota.transacciones, true)
        ).format("(0,0.00)"),
        Acumulado: numeral(acc).format("(0,0.00)")
      });

      cuota.transacciones.forEach(transac => {
        if (transac.PagoId && transac.pago) {
          xlsData.push({
            Concepto: `${transac.concepto} ${moment(transac.pago.fecha)
              .parseZone()
              .format("DD/MM/YYYY")}`,
            Periodo: ``,
            Vencimiento: ``,
            Monto: numeral(transac.monto).format("(0,0.00)"),
            Saldo: `---`,
            Acumulado: `---`
          });
        }
      });
    });

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(xlsData);

    XLSX.utils.book_append_sheet(wb, ws, "Hoja1");

    XLSX.writeFile(wb, `${snakeCase(data.concepto)}.xlsx`);
  };

  componentDidMount() {
    this.findPrestamo();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.prestamo !== prevProps.match.params.prestamo) {
      this.findPrestamo();
    }
  }

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps(dispatch) {
    return {
      navigate: path => {
        dispatch(push(path));
      }
    };
  }

  render() {
    const {
      data,
      loading,
      asentarRendicionModal,
      paymentModal,
      editCuotaModal,
      removePagoModal,
      nuevaCuotaModal,
      erogacionModal,
      removeRendicionModal
    } = this.state;

    if (loading) {
      return <Loader active inline content="Cargando..." />;
    } else if (data && data.cuotas) {
      return (
        <div>
          <Segment.Group>
            <Segment clearing>
              <Header as="h4">
                <Header.Content>
                  {data.concepto}
                  <Header.Subheader>
                    {!!data.numeroPrestamo
                      ? `Prestamo Nº ${data.numeroPrestamo}`
                      : ""}
                  </Header.Subheader>
                  <Header.Subheader>
                    Otorgado el{" "}
                    {moment(data.fechaOtorgado)
                      .parseZone()
                      .format("DD/MM/YYYY")}{" "}
                    - Inicio el{" "}
                    {moment(data.fechaInicio)
                      .parseZone()
                      .format("DD/MM/YYYY")}
                  </Header.Subheader>
                  <Header.Subheader>
                    Vencimiento de rendicion el{" "}
                    {moment(data.vencimientoRendicion)
                      .parseZone()
                      .format("DD/MM/YYYY")}
                  </Header.Subheader>
                  <Header.Subheader>
                    Entrego rendicion el{" "}
                    {data.rendicion
                      ? moment(data.rendicion.fechaRendicion)
                          .parseZone()
                          .format("DD/MM/YYYY")
                      : "---"}
                  </Header.Subheader>
                </Header.Content>
              </Header>
              <Button.Group>
                {data.rendicion && (
                  <Button
                    negative
                    icon="trash"
                    onClick={this.openBorrarRendicionModal.bind(
                      null,
                      data.rendicion
                    )}
                  />
                )}
                <Button
                  content="Asentar Rendicion"
                  icon="clipboard"
                  onClick={this.openAsentarRendicionModal}
                />
              </Button.Group>
              <Button
                floated="right"
                content="Descargar Excel"
                icon="download"
                onClick={this.downloadExcel}
              />
            </Segment>
            <Segment clearing>
              <Button
                content="Cancelar Deuda"
                icon="ban"
                basic
                negative
                onClick={this.cancelarDeuda}
              />
              <Button
                content="Pago"
                icon="plus"
                floated="right"
                primary
                onClick={this.openPaymentModal}
              />
              <Button
                content="Cuota"
                icon="plus"
                floated="right"
                onClick={this.openNuevaCuotaModal}
              />
            </Segment>
            <Segment>
              <ReactTable
                className="-striped -highlight"
                noDataText={"Sin Registros"}
                loadingText={"Cargando..."}
                showPagination={false}
                defaultPageSize={data.cuotas.length}
                pageSizeOptions={[data.cuotas.length]}
                data={data.cuotas}
                columns={[
                  {
                    Header: "Cuota",
                    columns: [
                      {
                        Header: "Nro",
                        accessor: "nro",
                        width: 48,
                        style: {
                          textAlign: "center"
                        }
                      },
                      {
                        Header: "Concepto",
                        accessor: "concepto"
                      }
                    ]
                  },
                  {
                    Header: "Periodo",
                    columns: [
                      {
                        Header: "Periodo Desde",
                        id: "periodoDesde",
                        accessor: cuota => {
                          let periodoDesde = moment(cuota.periodoDesde);
                          let utcOffset = periodoDesde.utcOffset();

                          periodoDesde[utcOffset <= 0 ? "add" : "subtract"](
                            Math.abs(utcOffset),
                            "minutes"
                          );

                          return periodoDesde.format("DD/MM/YYYY");
                        },
                        width: 128,
                        style: {
                          textAlign: "center"
                        }
                      },
                      {
                        Header: "Periodo Hasta",
                        id: "periodoHasta",
                        accessor: cuota => {
                          let periodoHasta = moment(cuota.periodoHasta);
                          let utcOffset = periodoHasta.utcOffset();

                          periodoHasta[utcOffset <= 0 ? "add" : "subtract"](
                            Math.abs(utcOffset),
                            "minutes"
                          );

                          return periodoHasta.format("DD/MM/YYYY");
                        },
                        width: 128,
                        style: {
                          textAlign: "center"
                        }
                      },
                      {
                        Header: "Vencimiento",
                        id: "vencimiento",
                        accessor: cuota => {
                          let vencimiento = moment(cuota.vencimiento);
                          let utcOffset = vencimiento.utcOffset();

                          vencimiento[utcOffset <= 0 ? "add" : "subtract"](
                            Math.abs(utcOffset),
                            "minutes"
                          );

                          return vencimiento.format("DD/MM/YYYY");
                        },
                        width: 128,
                        style: {
                          textAlign: "center"
                        }
                      }
                    ]
                  },
                  {
                    Header: "Saldo",
                    columns: [
                      {
                        Header: "",
                        width: 32,
                        Cell: row => (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              textAlign: "center"
                            }}>
                            <Icon
                              className="edit-icon-hover"
                              name="edit"
                              onClick={e =>
                                this.openEditCuotaModal(e, row.original)
                              }
                            />
                          </div>
                        ),
                        sortable: false,
                        resizable: false
                      },
                      {
                        Header: "Original",
                        accessor: "monto",
                        style: {
                          textAlign: "right"
                        }
                      },
                      {
                        Header: "Actual",
                        id: "saldo",
                        Cell: row => {
                          let saldoCuota = this.calcultarSaldoCuota(
                            row.original.transacciones
                          );

                          return (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                textAlign: "right",
                                color: saldoCuota < 0 ? "red" : "grey"
                              }}>
                              <div
                                style={{
                                  width: `100%`,
                                  height: "100%"
                                }}>
                                {saldoCuota}
                              </div>
                            </div>
                          );
                        },
                        getFooterProps: () => ({
                          style: { textAlign: "right" }
                        }),
                        Footer: () => {
                          let saldo = data.cuotas.reduce((prev, curr) => {
                            return (
                              prev +
                              this.calcultarSaldoCuota(curr.transacciones, true)
                            );
                          }, 0);

                          return (
                            <span style={{ color: saldo < 0 ? "red" : "grey" }}>
                              <strong>
                                {numeral(saldo).format("(0,0.00)")}
                              </strong>
                            </span>
                          );
                        }
                      },
                      {
                        Header: "Acumulado",
                        id: "acumulado",
                        Cell: row => {
                          let saldo = numeral();

                          for (let i = 0; i < row.original.nro; i++) {
                            let cuota = find(data.cuotas, cuota => {
                              return cuota.nro === i + 1;
                            });

                            if (cuota) {
                              saldo.add(
                                this.calcultarSaldoCuota(
                                  cuota.transacciones,
                                  true
                                )
                              );
                            }
                          }

                          return (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                textAlign: "right",
                                color: saldo.value() < 0 ? "red" : "grey"
                              }}>
                              <div
                                style={{
                                  width: `100%`,
                                  height: "100%"
                                }}>
                                {saldo.format("(0,0.00)")}
                              </div>
                            </div>
                          );
                        }
                      }
                    ]
                  }
                ]}
                SubComponent={row => {
                  return (
                    <div style={{ border: "1px solid grey" }}>
                      <ReactTable
                        className="-striped -highlight"
                        noDataText={"Sin Registros"}
                        loadingText={"Cargando..."}
                        defaultPageSize={row.original.transacciones.length}
                        showPagination={false}
                        data={row.original.transacciones}
                        columns={[
                          {
                            Header: "Transacciones",
                            columns: [
                              {
                                Header: "Concepto",
                                accessor: "concepto"
                              },
                              {
                                Header: "Fecha",
                                id: "fecha",
                                Cell: row => {
                                  if (row.original.pago) {
                                    return moment(row.original.pago.fecha)
                                      .parseZone()
                                      .format("DD/MM/YYYY");
                                  }
                                }
                              },
                              {
                                Header: "Monto",
                                id: "monto",
                                Cell: row => (
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      textAlign: "right"
                                    }}>
                                    <div
                                      style={{
                                        width: `100%`,
                                        height: "100%",
                                        color:
                                          numeral(row.original.monto).value() <
                                          0
                                            ? "red"
                                            : "black"
                                      }}>
                                      {numeral(row.original.monto).format(
                                        "(0,0.00)"
                                      )}
                                    </div>
                                  </div>
                                )
                              },
                              {
                                Header: "",
                                width: 32,
                                Cell: row => (
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      textAlign: "center"
                                    }}>
                                    {row.original.PagoId ? (
                                      <Icon
                                        color="red"
                                        className="trash-icon-hover"
                                        name="trash"
                                        onClick={e =>
                                          this.openRemovePagoModal(
                                            e,
                                            row.original.id
                                          )
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ),
                                sortable: false,
                                resizable: false
                              }
                            ]
                          }
                        ]}
                      />
                    </div>
                  );
                }}
              />
            </Segment>
          </Segment.Group>

          <Modal
            open={paymentModal.open}
            onClose={this.dissmissPaymentModal}
            closeOnEscape={paymentModal.loading}
            closeOnDimmerClick={paymentModal.loading}>
            <Modal.Header>Nuevo Pago</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                <Form>
                  <Form.Group>
                    <Form.Input
                      label="Concepto"
                      width={5}
                      name="concepto"
                      disabled={paymentModal.loading}
                      value={paymentModal.values.concepto}
                      onChange={this.modalInputHandler}
                    />
                    <Form.Input
                      label="Fecha"
                      width={5}
                      name="fecha"
                      type="date"
                      disabled={paymentModal.loading}
                      value={paymentModal.values.fecha}
                      onChange={this.modalInputHandler}
                    />
                  </Form.Group>
                </Form>
                <ReactTable
                  className="-striped -highlight"
                  noDataText={"Sin Registros"}
                  loadingText={"Cargando..."}
                  defaultPageSize={data.cuotas.length}
                  pageSizeOptions={[data.cuotas.length]}
                  showPagination={false}
                  data={data.cuotas}
                  columns={[
                    {
                      Header: "Cuota",
                      columns: [
                        {
                          Header: "Nro",
                          accessor: "nro",
                          width: 48,
                          style: {
                            textAlign: "center"
                          }
                        },
                        {
                          Header: "Concepto",
                          accessor: "concepto"
                        }
                      ]
                    },
                    {
                      Header: "Periodo",
                      columns: [
                        {
                          Header: "Periodo Desde",
                          id: "periodoDesde",
                          accessor: cuota => {
                            let periodoDesde = moment(cuota.periodoDesde);
                            let utcOffset = periodoDesde.utcOffset();

                            periodoDesde[utcOffset <= 0 ? "add" : "subtract"](
                              Math.abs(utcOffset),
                              "minutes"
                            );

                            return periodoDesde.format("DD/MM/YYYY");
                          },
                          width: 128,
                          style: {
                            textAlign: "center"
                          }
                        },
                        {
                          Header: "Periodo Hasta",
                          id: "periodoHasta",
                          accessor: cuota => {
                            let periodoHasta = moment(cuota.periodoHasta);
                            let utcOffset = periodoHasta.utcOffset();

                            periodoHasta[utcOffset <= 0 ? "add" : "subtract"](
                              Math.abs(utcOffset),
                              "minutes"
                            );

                            return periodoHasta.format("DD/MM/YYYY");
                          },
                          width: 128,
                          style: {
                            textAlign: "center"
                          }
                        },
                        {
                          Header: "Vencimiento",
                          id: "vencimiento",
                          accessor: cuota => {
                            let vencimiento = moment(cuota.vencimiento);
                            let utcOffset = vencimiento.utcOffset();

                            vencimiento[utcOffset <= 0 ? "add" : "subtract"](
                              Math.abs(utcOffset),
                              "minutes"
                            );

                            return vencimiento.format("DD/MM/YYYY");
                          },
                          width: 128,
                          style: {
                            textAlign: "center"
                          }
                        }
                      ]
                    },
                    {
                      Header: "Saldo",
                      columns: [
                        {
                          Header: "Actual",
                          id: "saldo",
                          Cell: row => (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                textAlign: "right"
                              }}>
                              <div
                                style={{
                                  width: `100%`,
                                  height: "100%"
                                }}>
                                {this.calcultarSaldoCuota(
                                  row.original.transacciones
                                )}
                              </div>
                            </div>
                          )
                        },
                        {
                          Header: "Pago",
                          id: "pagar",
                          Cell: this.renderEditable(),
                          getFooterProps: () => ({
                            style: { textAlign: "right" }
                          }),
                          Footer: (
                            <span>
                              <strong>
                                {numeral(
                                  data.cuotas
                                    .filter(cuota => cuota.incluirPago)
                                    .reduce((prev, curr) => {
                                      return prev + numeral(curr.pagar).value();
                                    }, 0)
                                ).format("0,0.00")}
                              </strong>
                            </span>
                          )
                        }
                      ]
                    },
                    {
                      Header: "",
                      id: "incluirPago",
                      width: 32,
                      Cell: cellInfo => (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            textAlign: "center"
                          }}>
                          <Checkbox
                            disabled={
                              numeral(
                                this.calcultarSaldoCuota(
                                  cellInfo.original.transacciones
                                )
                              ).value() === 0 || paymentModal.loading
                            }
                            checked={cellInfo.original.incluirPago}
                            onChange={e => this.incluirPago(cellInfo)}
                          />
                        </div>
                      ),
                      sortable: false,
                      resizable: false
                    }
                  ]}
                />
              </Modal.Description>
              {paymentModal.error && (
                <Message negative>
                  <Message.Header>{paymentModal.error.name}</Message.Header>
                  <p>{paymentModal.error.message}</p>
                </Message>
              )}
            </Modal.Content>
            <Modal.Actions>
              <Button
                disabled={paymentModal.loading}
                content="Cancelar"
                icon="remove"
                negative
                basic
                onClick={this.dissmissPaymentModal}
              />
              <Button
                disabled={paymentModal.loading}
                content={paymentModal.loading ? "Procesando..." : "Aceptar"}
                icon="payment"
                positive
                onClick={this.submitPago}
              />
            </Modal.Actions>
          </Modal>

          <Modal
            open={editCuotaModal.open}
            onClose={this.dismissEditCuotaModal}
            size="small"
            closeOnEscape={editCuotaModal.loading}
            closeOnDimmerClick={editCuotaModal.loading}>
            <Modal.Header>Ajuste Cuota</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                <Header>{editCuotaModal.values.concepto}</Header>
                <Header.Subheader>
                  Monto original: {editCuotaModal.values.montoOriginal}
                </Header.Subheader>
                <Header.Subheader>
                  Saldo Actual:{" "}
                  {this.calcultarSaldoCuota(
                    editCuotaModal.values.transacciones
                  )}
                </Header.Subheader>
                <Divider />
                <Form loading={editCuotaModal.loading}>
                  <Form.Group>
                    <Form.Input
                      name="monto"
                      label="Ajuste (Nuevo Saldo)"
                      width={6}
                      children={
                        <MaskedInput
                          name="monto"
                          mask={numberMask}
                          value={editCuotaModal.values.monto}
                          onChange={this.editCuotaInputHandler}
                        />
                      }
                    />
                  </Form.Group>
                </Form>
              </Modal.Description>
              {editCuotaModal.error && (
                <Message negative>
                  <Message.Header>{editCuotaModal.error.name}</Message.Header>
                  <p>{editCuotaModal.error.message}</p>
                </Message>
              )}
            </Modal.Content>
            <Modal.Actions>
              <Button
                disabled={editCuotaModal.loading}
                floated="left"
                content="Eliminar Cuota"
                icon="trash"
                negative
                basic
                onClick={this.removeCuota}
              />
              <Button
                disabled={editCuotaModal.loading}
                content="Cancelar"
                icon="remove"
                negative
                basic
                onClick={this.dismissEditCuotaModal}
              />
              <Button
                disabled={editCuotaModal.loading}
                content={editCuotaModal.loading ? "Procesando..." : "Aceptar"}
                icon="checkmark"
                positive
                onClick={this.submitCuotaEdition}
              />
            </Modal.Actions>
          </Modal>

          <Modal
            open={removePagoModal.open}
            basic
            size="small"
            dimmer="blurring"
            onClose={this.dismissRemovePagoModal}
            closeOnEscape={!removePagoModal.loading}
            closeOnDimmerClick={!removePagoModal.loading}>
            <Header icon="trash" content="Eliminar Transaccion" />
            <Modal.Content>
              <p>Eliminar Transaccion?</p>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="red"
                disabled={removePagoModal.loading}
                inverted
                onClick={this.dismissRemovePagoModal}>
                <Icon name="remove" /> No
              </Button>
              <Button
                color="green"
                disabled={removePagoModal.loading}
                inverted
                onClick={this.submitRemoveTransaccion}>
                <Icon name="checkmark" />{" "}
                {removePagoModal.loading ? "Procesando..." : "Si"}
              </Button>
            </Modal.Actions>
          </Modal>

          <Modal
            size="small"
            open={nuevaCuotaModal.open}
            onClose={this.dismissNuevaCuotaModal}
            closeOnEscape={nuevaCuotaModal.loading}
            closeOnDimmerClick={nuevaCuotaModal.loading}>
            <Header icon="plus" content="Nueva Cuota" />
            <Modal.Content>
              <Segment
                style={{
                  marginBottom: 16,
                  marginTop: 0,
                  paddingTop: 0,
                  paddingBottom: 22
                }}
                vertical
                textAlign={nuevaCuotaModal.values.mode ? "left" : "center"}>
                {!nuevaCuotaModal.values.mode ? (
                  <Button.Group>
                    <Button
                      name="mode"
                      value="single"
                      onClick={this.nuevaCuotaInputHandler}>
                      Crear Una
                    </Button>
                    <Button.Or text="<>" />
                    <Button
                      name="mode"
                      value="multiple"
                      onClick={this.nuevaCuotaInputHandler}>
                      Crear Multiples
                    </Button>
                  </Button.Group>
                ) : (
                  <Button
                    name="mode"
                    icon="arrow left"
                    content="Volver"
                    value=""
                    onClick={this.nuevaCuotaInputHandler}
                  />
                )}
              </Segment>
              {nuevaCuotaModal.values.mode ? (
                nuevaCuotaModal.values.mode === "single" ? (
                  <Form
                    disabled={nuevaCuotaModal.loading}
                    loading={nuevaCuotaModal.loading}>
                    <Form.Group>
                      <Form.Input
                        name="nro"
                        label="Nro"
                        value={nuevaCuotaModal.values.nro}
                        onChange={this.nuevaCuotaInputHandler}
                        type="number"
                        min={1}
                      />
                      <Form.Input
                        name="concepto"
                        label="Concepto"
                        value={nuevaCuotaModal.values.concepto}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                      <Form.Input
                        name="monto"
                        label="Monto"
                        children={
                          <MaskedInput
                            name="monto"
                            mask={numberMask}
                            value={nuevaCuotaModal.values.monto}
                            onChange={this.nuevaCuotaInputHandler}
                          />
                        }
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Input
                        name="periodoDesde"
                        label="Periodo Desde"
                        type="date"
                        value={nuevaCuotaModal.values.periodoDesde}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                      <Form.Input
                        name="periodoHasta"
                        label="Periodo Hasta"
                        type="date"
                        value={nuevaCuotaModal.values.periodoHasta}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                      <Form.Input
                        name="vencimiento"
                        label="Vencimiento"
                        type="date"
                        value={nuevaCuotaModal.values.vencimiento}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                    </Form.Group>
                  </Form>
                ) : (
                  <Form>
                    <Form.Group>
                      <Form.Input
                        name="concepto"
                        label="Concepto"
                        value={nuevaCuotaModal.values.concepto}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                      <Form.Input
                        name="monto"
                        label="Monto"
                        children={
                          <MaskedInput
                            name="monto"
                            mask={numberMask}
                            value={nuevaCuotaModal.values.monto}
                            onChange={this.inputHandler}
                            onChange={this.nuevaCuotaInputHandler}
                          />
                        }
                      />
                      <Form.Input
                        name="periodoDesde"
                        label="A Partir de:"
                        type="date"
                        value={nuevaCuotaModal.values.periodoDesde}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Select
                        name="intervaloVencimiento"
                        label="Periodicidad"
                        options={intervaloVencimientoOptions}
                        value={nuevaCuotaModal.values.intervaloVencimiento}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                      <Form.Input
                        name="diaVencimiento"
                        label="Dia de Vencimiento"
                        type="number"
                        min={1}
                        max={31}
                        value={nuevaCuotaModal.values.diaVencimiento}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                      <Form.Input
                        name="cantidad"
                        label="Cantidad"
                        type="number"
                        min={1}
                        value={nuevaCuotaModal.values.cantidad}
                        onChange={this.nuevaCuotaInputHandler}
                      />
                    </Form.Group>
                  </Form>
                )
              ) : (
                ""
              )}
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="red"
                disabled={nuevaCuotaModal.loading}
                onClick={this.dismissNuevaCuotaModal}>
                <Icon name="remove" /> Cancelar
              </Button>
              <Button
                color="green"
                disabled={nuevaCuotaModal.loading}
                onClick={this.submitNuevaCuota}>
                <Icon name="checkmark" />{" "}
                {nuevaCuotaModal.loading ? "Procesando..." : "Aceptar"}
              </Button>
            </Modal.Actions>
          </Modal>

          <Modal
            open={asentarRendicionModal.open}
            onClose={this.dismissAsentarRendicionModal}
            closeOnEscape={asentarRendicionModal.loading}
            closeOnDimmerClick={asentarRendicionModal.loading}>
            <Header icon="plus" content="Asentar Rendicion" />
            <Modal.Content>
              <Segment loading={asentarRendicionModal.loading} clearing>
                <Form loading={asentarRendicionModal.loading}>
                  <Form.Group>
                    <Form.Input
                      name="fechaRendicion"
                      label="Fecha"
                      type="date"
                      width={4}
                      value={asentarRendicionModal.values.fechaRendicion}
                      onChange={this.rendicionInputHandler}
                    />
                    <Form.Input
                      name="fondosRecibidos"
                      label="Fondos Recibidos"
                      width={4}
                      children={
                        <MaskedInput
                          name="fondosRecibidos"
                          mask={numberMask}
                          value={asentarRendicionModal.values.fondosRecibidos}
                          onChange={this.rendicionInputHandler}
                        />
                      }
                    />
                    <Form.Input
                      name="importeRendicion"
                      label="Importe Rendicion"
                      width={4}
                      children={
                        <MaskedInput
                          name="importeRendicion"
                          mask={numberMask}
                          disabled
                          value={asentarRendicionModal.values.importeRendicion}
                          onChange={this.rendicionInputHandler}
                        />
                      }
                    />
                    <Form.Input
                      name="saldoPorRendir"
                      label="Saldo Por Rendir"
                      width={4}
                      children={
                        <MaskedInput
                          name="saldoPorRendir"
                          mask={numberMask}
                          value={asentarRendicionModal.values.saldoPorRendir}
                          onChange={this.rendicionInputHandler}
                        />
                      }
                    />
                  </Form.Group>
                  <Button
                    color="green"
                    disabled={asentarRendicionModal.loading}
                    floated="right"
                    onClick={this.submitRendicion}>
                    <Icon name="checkmark" />{" "}
                    {asentarRendicionModal.loading
                      ? "Procesando..."
                      : "Aceptar"}
                  </Button>
                </Form>
              </Segment>
              <Segment
                disabled={asentarRendicionModal.loading || !data.rendicion}
                clearing
                vertical>
                <ReactTable
                  className="-striped -highlight"
                  noDataText={"Sin Registros"}
                  loadingText={"Cargando..."}
                  previousText={"<<<"}
                  nextText={">>>"}
                  pageText={"Pagina"}
                  ofText={"de"}
                  rowsText={"filas"}
                  defaultPageSize={5}
                  data={data.rendicion ? data.rendicion.erogaciones : []}
                  columns={[
                    {
                      Header: "Erogaciones",
                      columns: [
                        {
                          Header: "Fecha",
                          id: "fecha",
                          accessor: row =>
                            moment(row.fecha)
                              .parseZone()
                              .format("DD/MM/YYYY")
                        },
                        {
                          Header: "Nro Comprobante",
                          accessor: "nroComprobante"
                        },
                        {
                          Header: "Razon Social",
                          accessor: "razonSocial"
                        },
                        {
                          Header: "Importe",
                          id: "importe",
                          Cell: row => (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                textAlign: "right"
                              }}>
                              <div
                                style={{
                                  width: `100%`,
                                  height: "100%"
                                }}>
                                {numeral(row.original.importe).format(
                                  "(0,0.00)"
                                )}
                              </div>
                            </div>
                          )
                        },
                        {
                          Header: "",
                          width: 32,
                          Cell: row => (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                textAlign: "center"
                              }}>
                              <Icon
                                color="red"
                                className="trash-icon-hover"
                                name="trash"
                                onClick={this.removeErogacion.bind(
                                  null,
                                  row.original
                                )}
                              />
                            </div>
                          ),
                          sortable: false,
                          resizable: false
                        }
                      ]
                    }
                  ]}
                />
                <Button
                  primary
                  disabled={asentarRendicionModal.loading}
                  floated="right"
                  onClick={this.openErogacionModal}>
                  <Icon name="add" />{" "}
                  {asentarRendicionModal.loading
                    ? "Procesando..."
                    : "Agregar Erogacion"}
                </Button>
              </Segment>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="red"
                disabled={asentarRendicionModal.loading}
                onClick={this.dismissAsentarRendicionModal}>
                <Icon name="remove" /> Cancelar
              </Button>
            </Modal.Actions>
          </Modal>

          <Modal
            open={erogacionModal.open}
            onClose={this.dismissErogacionModal}
            size="small"
            closeOnEscape={erogacionModal.loading}
            closeOnDimmerClick={erogacionModal.loading}>
            <Header icon="plus" content="Asentar Rendicion" />
            <Modal.Content>
              <Form loading={erogacionModal.loading}>
                <Form.Input
                  name="fecha"
                  label="Fecha"
                  type="date"
                  value={erogacionModal.values.fecha}
                  onChange={this.erogacionInputHandler}
                />
                <Form.Input
                  name="nroComprobante"
                  label="Nro Comprobante"
                  value={erogacionModal.values.nroComprobante}
                  onChange={this.erogacionInputHandler}
                />
                <Form.Input
                  name="razonSocial"
                  label="Razon Social"
                  value={erogacionModal.values.razonSocial}
                  onChange={this.erogacionInputHandler}
                />
                <Form.Input
                  name="importe"
                  label="Importe"
                  width={4}
                  children={
                    <MaskedInput
                      name="importe"
                      mask={numberMask}
                      value={erogacionModal.values.importe}
                      onChange={this.erogacionInputHandler}
                    />
                  }
                />
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="red"
                disabled={erogacionModal.loading}
                onClick={this.dismissErogacionModal}>
                <Icon name="remove" /> Cancelar
              </Button>
              <Button
                color="green"
                disabled={erogacionModal.loading}
                onClick={this.submitErogacion}>
                <Icon name="checkmark" />{" "}
                {erogacionModal.loading ? "Procesando..." : "Aceptar"}
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            open={removeRendicionModal.open}
            basic
            size="small"
            dimmer="blurring"
            onClose={this.dismissRendicionModal}
            closeOnEscape={!removeRendicionModal.loading}
            closeOnDimmerClick={!removeRendicionModal.loading}>
            <Header icon="trash" content="Eliminar Rendicion" />
            <Modal.Content>
              <p>Eliminar Rendicion?</p>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="red"
                disabled={removeRendicionModal.loading}
                inverted
                onClick={this.dismissRendicionModal}>
                <Icon name="remove" /> No
              </Button>
              <Button
                color="green"
                disabled={removeRendicionModal.loading}
                inverted
                onClick={this.submitRemoveRendicion}>
                <Icon name="checkmark" />{" "}
                {removeRendicionModal.loading ? "Procesando..." : "Si"}
              </Button>
            </Modal.Actions>
          </Modal>
        </div>
      );
    } else {
      return <div>SIN DATOS</div>;
    }
  }
}

export default connect(
  CoopPrestamosDetalleView.mapStateToProps,
  CoopPrestamosDetalleView.mapDispatchToProps
)(CoopPrestamosDetalleView);



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopPrestamosDetalleView.js